import DataLoggerRouter from "@/context/data_logger/router/DataLoggerRouter";
import {Api} from "@/common/api/Api";
import {axiosInstance} from "@/plugins/axios";
import {AxiosInstance, AxiosResponse} from "axios";

export class DataLoggerApi extends Api {
  constructor(axios: AxiosInstance) {
    super(DataLoggerRouter.BASE_PATH, axios);
  }

  public static async findPage(query: string): Promise<AxiosResponse> {
    const response: AxiosResponse = await axiosInstance.get(
      DataLoggerRouter.BASE_PATH + "/p?" + query
    );
    return response;
  }

  async configurationOverview(id: number) {
    const response: AxiosResponse = await axiosInstance.get(
      `${DataLoggerRouter.BASE_PATH}/configuration_overview?dataLoggerId=${id}`
    );
    return response;
  }


  async createDataLoggerFromConfigurationInitialData() {
    const response: AxiosResponse = await axiosInstance.get(
      `${DataLoggerRouter.BASE_PATH}/create_from_configuration/initial_data`
    );
    return response;
  }

  async createDataLogger(data: any) {
    const response: AxiosResponse = await axiosInstance.post(
      `${DataLoggerRouter.BASE_PATH}/create_from_configuration/create`, data
    );
    return response;
  }
  async validateIdentifierUnique(identifier: string, excludeId?: number): Promise<{ unique: boolean; message: string }> {
    const params: Record<string, string> = { identifier };
    if (excludeId != null) params.excludeId = String(excludeId);
    const response = await axiosInstance.get(
      `${DataLoggerRouter.BASE_PATH}/validate/identifier-unique`, { params }
    );
    return response.data;
  }

  async createDataLoggerPreview(data: any) {
    const response: AxiosResponse = await axiosInstance.post(
      `${DataLoggerRouter.BASE_PATH}/create_from_configuration/create_preview`, data
    );
    return response;
  }
}

export const dataLoggerApi = new DataLoggerApi(axiosInstance);
